import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme/theme";
import AnnapurnaMarriages from "./pages/AnnapurnaMarriages";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProfileLayout from "./components/layout/ProfileLayout.jsx";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import About from "./components/homepage/userdashbord/About.jsx";
// import Help from "./components/homepage/userdashbord/Help.jsx";
import Contact from "./components/homepage/userdashbord/Contact.jsx";
import Carrers from "./components/homepage/userdashbord/Carrers.jsx";
import TokenSaver from "./tokenSaver.jsx";
import Cmd from "./components/homepage/userdashbord/Cmd.jsx";
import Faq from "./components/homepage/userdashbord/Faq.jsx";
import ContactAdmin from "./components/homepage/userdashbord/ContactAdmin.jsx";
import  Advertisement from "./components/homepage/userdashbord/Advertisement.jsx"
import DemoVideo from "./components/homepage/userdashbord/DemoVideo.jsx";

function App() {

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<BrowserRouter>
			<TokenSaver />
				<Routes>
				<Route path="/About" element={<About />} />
				{/* <Route path="/Help" element={<Help/>}/> */}
				<Route path="/Contact" element={<Contact/>}/>
				<Route path="/Career" element={<Carrers/>}/>
				<Route path="/Cmd" element={<Cmd/>}/>
				<Route path="/Faq" element={<Faq/>}/>
				<Route path="/Contact-admin" element={<ContactAdmin/>}/>
				<Route path="/Advertisement" element={< Advertisement/>}/>
				<Route path="/Demo-Video" element={<DemoVideo/>}/>
					<Route path="/" element={<AnnapurnaMarriages />} />
					<Route
						path="/profile/*"
						element={
							<ProtectedRoute>
								<ProfileLayout />
							</ProtectedRoute>
						}
					/>
				</Routes>
			</BrowserRouter>
		</ThemeProvider>
	);
}

export default App;
